import N8nUserInfo from './UserInfo.vue';

export default N8nUserInfo;
